shadow$provide[255] = function(require,module,exports) {
Object.defineProperties(exports, {__esModule:{enumerable:true, value:true}, DOM:{enumerable:true, get:function() {
  return DOM;
}}});
var require$_DOT__DOT__SLASH__DOT__DOT__SLASH_primitive_DOT_js = require("../../primitive.js");
class DOM extends require$_DOT__DOT__SLASH__DOT__DOT__SLASH_primitive_DOT_js.Primitive {
  static initClass() {
    this.traits = ["node", "bind", "object", "visible", "overlay", "dom", "attach", "position",];
  }
  init() {
    this.emitter = this.root = null;
    this.active = {};
  }
  make() {
    super.make();
    this._helpers.bind.make([{to:"dom.html", trait:"html"}, {to:"dom.points", trait:"source"},]);
    if (this.bind.points == null || this.bind.html == null) {
      return;
    }
    this.root = this._inherit("root");
    this._listen("root", "root.update", this.update);
    this._listen("root", "root.post", this.post);
    const pointDims = this.bind.points.getDimensions();
    const htmlDims = this.bind.html.getDimensions();
    const items = Math.min(pointDims.items, htmlDims.items);
    const width = Math.min(pointDims.width, htmlDims.width);
    const height = Math.min(pointDims.height, htmlDims.height);
    const depth = Math.min(pointDims.depth, htmlDims.depth);
    let position = this.bind.points.sourceShader(this._shaders.shader());
    position = this._helpers.position.pipeline(position);
    const projection = this._shaders.shader({globals:["projectionMatrix"]});
    projection.pipe("project.readback");
    position.pipe(projection);
    const indexer = this._shaders.shader();
    this.readback = this._renderables.make("readback", {map:position, indexer, items, width, height, depth, channels:4, stpq:true,});
    this.dom = this._overlays.make("dom");
    this.dom.hint(items * width * height * depth * 2);
    this.emitter = this.callback(this.bind.html.nodes());
    this.readback.setCallback(this.emitter);
    this._helpers.visible.make();
  }
  unmake() {
    if (this.readback != null) {
      this.readback.dispose();
      this.dom.dispose();
      this.readback = this.dom = null;
      this.root = null;
      this.emitter = null;
      this.active = {};
    }
    this._helpers.bind.unmake();
    this._helpers.visible.unmake();
  }
  update() {
    if (this.readback == null) {
      return;
    }
    if (this.props.visible) {
      this.readback.update(this.root != null ? this.root.getCamera() : undefined);
      this.readback.post();
      this.readback.iterate();
    }
  }
  post() {
    if (this.readback == null) {
      return;
    }
    this.dom.render(this.isVisible ? this.emitter.nodes() : null);
  }
  callback(data) {
    let strideJ, strideK;
    const uniforms = this._inherit("unit").getUnitUniforms();
    const width = uniforms.viewWidth;
    const height = uniforms.viewHeight;
    const attr = this.node.attributes["dom.attributes"];
    const size = this.node.attributes["dom.size"];
    const zoom = this.node.attributes["dom.zoom"];
    const color = this.node.attributes["dom.color"];
    const outline = this.node.attributes["dom.outline"];
    const pointer = this.node.attributes["dom.pointerEvents"];
    const opacity = this.node.attributes["overlay.opacity"];
    const zIndex = this.node.attributes["overlay.zIndex"];
    const offset = this.node.attributes["attach.offset"];
    const depth = this.node.attributes["attach.depth"];
    const snap = this.node.attributes["attach.snap"];
    const {el} = this.dom;
    let nodes = [];
    let styles = null;
    let className = null;
    let strideI = strideJ = strideK = 0;
    let colorString = "";
    const f = function(x, y, z, w, i, j, k, l) {
      let v;
      const index = l + strideI * i + strideJ * j + strideK * k;
      const children = data[index];
      const clip = w < 0;
      const iw = 1 / w;
      const flatZ = 1 + (iw - 1) * depth.value;
      const scale = clip ? 0 : flatZ;
      const ox = +offset.value.x * scale;
      const oy = +offset.value.y * scale;
      let xx = (x + 1) * width.value * 0.5 + ox;
      let yy = (y - 1) * height.value * 0.5 + oy;
      xx /= zoom.value;
      yy /= zoom.value;
      if (snap.value) {
        xx = Math.round(xx);
        yy = Math.round(yy);
      }
      const alpha = Math.min(0.999, clip ? 0 : opacity.value);
      const props = {className, style:{transform:`translate3d(${xx}px, ${-yy}px, ${1 - w}px) translate(-50%, -50%) scale(${scale},${scale})`, opacity:alpha,},};
      for (k in styles) {
        v = styles[k];
        props.style[k] = v;
      }
      const a = attr.value;
      if (a != null) {
        const s = a.style;
        for (k in a) {
          v = a[k];
          if (!["style", "className"].includes(k)) {
            props[k] = v;
          }
        }
        if (s != null) {
          for (k in s) {
            v = s[k];
            props.style[k] = v;
          }
        }
      }
      props.className += " " + ((a != null ? a.className : undefined) != null ? a != null ? a.className : undefined : "mathbox-label");
      return nodes.push(el("div", props, children));
    };
    f.reset = () => {
      nodes = [];
      [strideI, strideJ, strideK] = Array.from([this.strideI, this.strideJ, this.strideK,]);
      const c = color.value;
      const m = x => Math.floor(x * 255);
      colorString = c ? `rgb(${[m(c.x), m(c.y), m(c.z)]})` : "";
      className = `mathbox-outline-${Math.round(outline.value)}`;
      styles = {};
      if (c) {
        styles.color = colorString;
      }
      styles.fontSize = `${size.value}px`;
      if (zoom.value !== 1) {
        styles.zoom = zoom.value;
      }
      if (zIndex.value > 0) {
        styles.zIndex = zIndex.value;
      }
      if (pointer.value) {
        return styles.pointerEvents = "auto";
      }
    };
    f.nodes = () => nodes;
    return f;
  }
  resize() {
    let sI, sJ;
    if (this.readback == null) {
      return;
    }
    const pointDims = this.bind.points.getActiveDimensions();
    const htmlDims = this.bind.html.getActiveDimensions();
    const items = Math.min(pointDims.items, htmlDims.items);
    const width = Math.min(pointDims.width, htmlDims.width);
    const height = Math.min(pointDims.height, htmlDims.height);
    const depth = Math.min(pointDims.depth, htmlDims.depth);
    this.readback.setActive(items, width, height, depth);
    this.strideI = sI = htmlDims.items;
    this.strideJ = sJ = sI * htmlDims.width;
    this.strideK = sJ * htmlDims.height;
  }
  change(changed, _touched, _init) {
    if (changed["dom.html"] || changed["dom.points"]) {
      return this.rebuild();
    }
  }
}
DOM.initClass();

};